/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIResponseError
 */
export interface APIResponseError {
    /**
     * 
     * @type {number}
     * @memberof APIResponseError
     */
    httpcode?: number;
    /**
     * 
     * @type {string}
     * @memberof APIResponseError
     */
    message?: string;
}

/**
 * Check if a given object implements the APIResponseError interface.
 */
export function instanceOfAPIResponseError(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function APIResponseErrorFromJSON(json: any): APIResponseError {
    return APIResponseErrorFromJSONTyped(json, false);
}

export function APIResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIResponseError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'httpcode': !exists(json, 'httpcode') ? undefined : json['httpcode'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function APIResponseErrorToJSON(value?: APIResponseError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'httpcode': value.httpcode,
        'message': value.message,
    };
}

